import { LabelDisplayedRowsArgs } from '@material-ui/core';
import { GridLocaleText } from '@material-ui/data-grid';

const PORTUGUESE_LOCALE_TEXT: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Nenhum dado',
  errorOverlayDefaultLabel: 'Um erro ocorreu.',

  // Density selector toolbar button text
  toolbarDensity: 'Densidade',
  toolbarDensityLabel: 'Densidade',
  toolbarDensityCompact: 'Compacto',
  toolbarDensityStandard: 'Normal',
  toolbarDensityComfortable: 'Confortável',

  // GridColumns selector toolbar button text
  toolbarColumns: 'Colunas',
  toolbarColumnsLabel: 'Mostrar Seletor de Colunas',

  // Filters toolbar button text
  toolbarFilters: 'Filtros',
  toolbarFiltersLabel: 'Mostrar Filtros',
  toolbarFiltersTooltipHide: 'Ocultar Filtros',
  toolbarFiltersTooltipShow: 'Mostrar Filtros',
  toolbarFiltersTooltipActive: (count: number): string =>
    `${count} filtro(s) ativo(s)`,

  // GridColumns panel text
  columnsPanelTextFieldLabel: 'Buscar coluna',
  columnsPanelTextFieldPlaceholder: 'Título da coluna',
  columnsPanelDragIconLabel: 'Reorder Column',
  columnsPanelShowAllButton: 'Mostrar Tudo',
  columnsPanelHideAllButton: 'Ocultar Tudo',

  // Filter panel text
  filterPanelAddFilter: 'Adicionar filtro',
  filterPanelDeleteIconLabel: 'Excluir',
  filterPanelOperators: 'Operadores',
  filterPanelOperatorAnd: 'E',
  filterPanelOperatorOr: 'Ou',
  filterPanelColumns: 'Colunas',
  filterPanelInputLabel: 'Valor',
  filterPanelInputPlaceholder: 'Filtrar valor',

  // Filter operators text
  filterOperatorContains: 'contém',
  filterOperatorEquals: 'é igual a',
  filterOperatorStartsWith: 'começa com',
  filterOperatorEndsWith: 'termina com',
  filterOperatorIs: 'é',
  filterOperatorNot: 'não é',
  filterOperatorOnOrAfter: 'em ou após',
  filterOperatorBefore: 'antes de',
  filterOperatorOnOrBefore: 'em ou antes de',
  filterOperatorAfter: 'após',
  filterOperatorIsEmpty: 'é vazio',
  filterOperatorIsNotEmpty: 'não é vazio',
  filterValueFalse: 'é falso',
  filterValueTrue: 'é verdadeiro',
  filterValueAny: 'qualquer valor',

  // Column menu text
  columnMenuLabel: 'Menu',
  columnMenuShowColumns: 'Mostrar colunas',
  columnMenuFilter: 'Filtro',
  columnMenuHideColumn: 'Esconder',
  columnMenuUnsort: 'Remover ordenação',
  columnMenuSortAsc: 'Ordenar Crescente',
  columnMenuSortDesc: 'Ordenar Decrescente',

  // Column header text
  columnHeaderFiltersTooltipActive: (count: number): string =>
    `${count} filtro(s) ativo(s)`,
  columnHeaderFiltersLabel: 'Mostrar Filtros',
  columnHeaderSortIconLabel: 'Ordenar',

  // Rows selected footer text
  footerRowSelected: (count: number): string =>
    count !== 1
      ? `${count.toLocaleString()} linhas selecionadas`
      : `${count.toLocaleString()} linha selecionada`,

  // Total rows footer text
  footerTotalRows: 'Quantidade de itens:',

  // Pagination footer text
  MuiTablePagination: {
    labelRowsPerPage: 'Linhas por página:',
    labelDisplayedRows: ({
      from,
      to,
      count,
      page,
    }: LabelDisplayedRowsArgs): string =>
      count ? `${from}-${to} de ${count} (Página ${page + 1})` : '',
  },
};

export default PORTUGUESE_LOCALE_TEXT;
